import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "./context/ThemeContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Industries from "./pages/Industries";
import Leadership from "./pages/Leadership";
import Vision from "./pages/Vision";
import SocialImpact from "./pages/SocialImpact";
import Financials from "./pages/Financials";
import CorporateBrief from "./pages/CorporateBrief";
import Contact from "./pages/Contact";
import ARAgent from "./components/ARAgent";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <ThemeProvider>
      <div className="App">
        <Toaster position="top-right" />
        <BrowserRouter>
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/industries" element={<Industries />} />
            <Route path="/leadership" element={<Leadership />} />
            <Route path="/vision" element={<Vision />} />
            <Route path="/social-impact" element={<SocialImpact />} />
            <Route path="/financials" element={<Financials />} />
            <Route path="/corporate-brief" element={<CorporateBrief />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
          <Footer />
          <ARAgent />
        </BrowserRouter>
      </div>
    </ThemeProvider>
  );
}

export default App;